import {
  NameCell,
  TypeCell,
  AmountCell,
  JobCell,
  DateCell,
  AdjustedAmountCell,
  ProjectCell,
} from "@/modules/work/billables/cells";
import { EmployeeCell } from "components/cell/employee/cell";
import { StatusCell } from "@/components/status/cell";

const baseColumns = {
  project: {
    id: "project",
    header: "Project",
    accessorKey: "project.name",
    cell: (info) => {
      const value = {
        getValue: () => info.getValue(),
        row: {
          original: {
            job: {
              project: {
                project_id: info.row.original.project.project_id,
              },
            },
          },
        },
      };
      return ProjectCell(value);
    },
  },
  job: {
    id: "job",
    header: "Job",
    accessorKey: "job.name",
    cell: JobCell,
  },
  type: {
    id: "type",
    header: "Type",
    accessorKey: "job.type",
    cell: TypeCell,
  },
  name: {
    id: "name",
    header: "Billable",
    accessorKey: "name",
    cell: NameCell,
  },
  amount: {
    id: "amount",
    header: "Amount",
    accessorKey: "amount",
    cell: AmountCell,
  },
  adjustedAmount: {
    id: "adjusted_amount",
    header: "Amount",
    accessorKey: "adjusted_amount",
    cell: AdjustedAmountCell,
  },
  billingDate: {
    id: "billing_date",
    header: "Billing Date",
    accessorKey: "billing_date",
    cell: DateCell,
  },
  dueDate: {
    id: "due_date",
    header: "Due Date",
    accessorKey: "due_date",
    cell: DateCell,
  },
  invoiceDate: {
    id: "invoice_date",
    header: "Invoice Date",
    accessorKey: "invoice_date",
    cell: DateCell,
  },
  forecastDate: {
    id: "forecast_date",
    header: "Forecast Date",
    accessorKey: "forecast_date",
    cell: DateCell,
  },
  collectedDate: {
    id: "collected_date",
    header: "Collected Date",
    accessorKey: "collected_date",
    cell: DateCell,
  },
  invoiceNumber: {
    id: "invoice_number",
    header: "Invoice Number",
    accessorKey: "invoice_number",
  },
  projectCoordinator: {
    id: "project-coordinator",
    header: "PC",
    accessorKey: "project.coordinator",
    cell: EmployeeCell,
  },
  accountManager: {
    id: "project-account-manager",
    header: "AM",
    accessorKey: "project.account_manager",
    cell: EmployeeCell,
  },
  salesCoordinator: {
    id: "project-sales-coordinator",
    header: "SC",
    accessorKey: "project.sales_coordinator",
    cell: EmployeeCell,
  },
  jobCoordinator: {
    id: "job-coordinator",
    header: "JC",
    accessorKey: "job.coordinator",
    cell: EmployeeCell,
  },
  status: {
    id: "status",
    header: "Status",
    accessorKey: "status",
    cell: StatusCell,
  },
};

const statusColumns = {
  contracted: [
    "project",
    "job",
    "name",
    "type",
    "amount",
    "billingDate",
    "projectCoordinator",
    "accountManager",
    "jobCoordinator",
    "salesCoordinator",
  ],
  pending_invoice: [
    "project",
    "job",
    "name",
    "type",
    "amount",
    "billingDate",
    "dueDate",
    "projectCoordinator",
    "accountManager",
    "jobCoordinator",
    "salesCoordinator",
  ],
  billed: [
    "project",
    "job",
    "name",
    "type",
    "adjustedAmount",
    "invoiceNumber",
    "billingDate",
    "invoiceDate",
    "dueDate",
    "forecastDate",
    "projectCoordinator",
    "accountManager",
    "jobCoordinator",
    "salesCoordinator",
  ],
  collected: [
    "project",
    "job",
    "name",
    "type",
    "adjustedAmount",
    "invoiceNumber",
    "billingDate",
    "invoiceDate",
    "dueDate",
    "forecastDate",
    "collectedDate",
    "projectCoordinator",
    "accountManager",
    "jobCoordinator",
    "salesCoordinator",
  ],
  cancelled: [
    "project",
    "job",
    "name",
    "type",
    "amount",
    "billingDate",
    "projectCoordinator",
    "accountManager",
    "jobCoordinator",
    "salesCoordinator",
  ],
  all: [
    "project",
    "job",
    "name",
    "status",
    "type",
    "amount",
    "billingDate",
    "invoiceDate",
    "projectCoordinator",
    "accountManager",
    "jobCoordinator",
    "salesCoordinator",
  ],
};

export const getChildColumns = (status) => {
  const keys = statusColumns[status] || statusColumns.contracted;
  return keys.map((key) => baseColumns[key]);
};
